'use strict';

angular.module('ClinicApp').directive('billingPeriodSelect', function($document, $filter) {
  return {
    require: 'ngModel',
    templateUrl: '/views/directives/_billing-period-select.html',
    scope: {
      billableMonthsByYear: '=billingPeriodSelect',
      onChange: '&',
      multiSelect: '=', // allow the multi-select if true.
    },
    link: function($scope, _el, _attrs, ngModel) {
      $scope.showDropdown = false;
      $scope.multiSelectControl = {
        enabled: false,
        touched: false,
        state: {}, // boolean states by the option key.
      };

      $scope.$watch('billableMonthsByYear', () => {
        $scope.options = [];

        for (const year of Object.keys($scope.billableMonthsByYear)) {
          for (const month of $scope.billableMonthsByYear[year]) {
            $scope.options.push({
              year: parseInt(year, 10),
              month,
            });
          }
        }

        $scope.options = _.sortBy($scope.options, $scope.getOptionKey).reverse();
      });

      $scope.toggleDropdown = () => {
        $scope.showDropdown = !$scope.showDropdown;
      };

      $scope.getOptionKey = (option) => `${option.year}-${_.padLeft(option.month, 2, '0')}`;

      $scope.selectOption = (option) => {
        if ($scope.multiSelectControl.enabled) {
          const optionKey = $scope.getOptionKey(option);
          $scope.multiSelectControl.state[optionKey] = !$scope.multiSelectControl.state[optionKey];
          $scope.multiSelectControl.touched = true;
        } else {
          $scope.showDropdown = false;
          ngModel.$setViewValue(option);
          $scope.onChange();
        }
      };

      $scope.isSelected = (option) => {
        let selectedOptions = Array.isArray(ngModel.$viewValue) ? ngModel.$viewValue : [ngModel.$viewValue];
        return selectedOptions
          .filter((selectedOption) => selectedOption?.year && selectedOption?.month)
          .some((selectedOption) => $scope.getOptionKey(selectedOption) === $scope.getOptionKey(option));
      };

      $scope.getSelectedLabel = () => {
        let selectedOptions = Array.isArray(ngModel.$viewValue) ? ngModel.$viewValue : [ngModel.$viewValue];
        selectedOptions = selectedOptions.filter((option) => option?.year && option?.month);

        if (!selectedOptions.length) {
          return;
        }

        let label = `${$filter('numberAsMonth')(selectedOptions[0].month)} ${selectedOptions[0].year}`;

        if (selectedOptions.length > 1) {
          label += ` & ${selectedOptions.length - 1} other`;
        }

        return label;
      };

      $scope.enableMultiSelect = () => {
        const selectedOption = ngModel.$viewValue;

        if (selectedOption) {
          $scope.multiSelectControl.state = {
            [$scope.getOptionKey(selectedOption)]: true,
          };
        }

        $scope.multiSelectControl.touched = false;
        $scope.multiSelectControl.enabled = true;
      };

      $scope.applyMultiSelectIsDisabled = () =>
        !($scope.options ?? []).some((option) => $scope.multiSelectControl.state[$scope.getOptionKey(option)]);

      $scope.applyMultiSelect = (selectAll = false) => {
        $scope.showDropdown = false;
        const options = $scope.options ?? [];

        if (selectAll) {
          for (const option of options) {
            $scope.multiSelectControl.state[$scope.getOptionKey(option)] = true;
          }
        }

        const selectedOptions = options.filter((option) =>
          $scope.multiSelectControl.state[$scope.getOptionKey(option)]);
        ngModel.$setViewValue(selectedOptions);
        $scope.onChange();
      };

      $scope.resetMultiSelect = () => {
        $scope.multiSelectControl.enabled = false;
        $scope.selectOption($scope.options?.[0]);
      };

      $scope.stopPropagation = (event) => {
        event.stopPropagation();
      };

      function handleOutsideClick() {
        $scope.showDropdown = false;
        $scope.$apply();
      }

      $document.on('click', handleOutsideClick);
      $scope.$on('$destroy', () => $document.off('click', handleOutsideClick));
    },
  };
});
